import { object } from '@hapi/joi';
import { CommonGet, CommonPost } from '../../../utils/CommonFetch';
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    getGroups,
    getFactories,
    getCollectionPoints,
    getAllOperationEntitiesForDropDown,
    getCollectionPointByOperationEntityId,
    getCustomersFromCollectionPoint,
    saveTransaction,
    GetCollectionTypeByOperationEntity
};

async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getCollectionPointByOperationEntityId(operationEntityID) {
    var collectionPointArray = [];
  
    var response = await CommonGet('/api/CollectionPoint/GetAllRoutesByFactoryID', 'factoryID=' + operationEntityID);
   
    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }

    return collectionPointArray;
}

async function getFactories() {
    var factoryArray = []
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null)
    return response.data;
}

async function getCollectionPoints() {
    var response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    return response.data;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getCustomersFromCollectionPoint(collectionPoint){
   // var cusArray = []
    const response = await CommonGet('/api/Customer/GetAllCustomerbyCollectionPointID', 'collectionPointID=' + collectionPoint)
    return response.data;
}


async function saveTransaction(data){
    // var cusArray = []
 
    const response = await CommonPost('/api/ManualLeafEntry/InsertLeafCollectionTransaction', null, data);
    return response;
 }

 
async function GetCollectionTypeByOperationEntity(id) {
    var productsArray = [];
    if (id.toString() === '0')
        return productsArray;

    var response = await CommonGet('/api/CollectionType/GetCollectionTypeByOperationEntity', 'id=' + id);

    for (let item of Object.entries(response.data)) {
        productsArray[item[1]["collectionTypeID"]] = item[1]["collectionTypeName"];
    }

    return productsArray;
}